export function formatDateToYYYYMMDD(date) {
  if (!date || typeof date !== "string") {
    throw new Error(
      "Invalid date input. Please provide a date string in YYYY-MM-DD format."
    );
  }

  // Validate the input format
  const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(date);
  if (!isValidFormat) {
    throw new Error("Date must be in YYYY-MM-DD format.");
  }

  // Remove dashes to format as YYYYMMDD
  return date.replace(/-/g, "");
}
